/**
 * Set of utils to properly handle number input
 * Typical use case:
 * - we use an input of type text
 * - we want to allow the user to type either . or , as decimal separator
 *
 * Example in the TransferContent components.
 */

// Parse user input to number, accepting both . and , as decimal separators
export const parseQuantityInput = (inputValue) => {
  if (!inputValue || inputValue === '') {
    return 0;
  }

  const normalizedValue = inputValue.replace(',', '.');
  const parsed = parseFloat(normalizedValue);

  return isNaN(parsed) ? 0 : Math.max(0, parsed); // Prevent negative quantities
};

// Format number for consistent display (always use period as decimal separator)
export const formatQuantityForDisplay = (inputValue) => {
  if (!inputValue || inputValue === '') {
    return '';
  }

  // Check if the input starts with '0.' or '0,' so we can still have numbers between 0 and 1
  if (/^0[.,].*$/.test(inputValue)) {
    return inputValue.replace(',', '.');
  }

  // Remove leading zeros and replace , with .
  return inputValue.replace(/^0+/, '').replace(',', '.');
};

// Validate if input is a valid number format
export const isValidNumberInput = (inputValue) => {
  if (!inputValue || inputValue === '') {
    return true;
  }

  return /^[0-9]*([.,][0-9]*)?$/.test(inputValue);
};
